import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { toast } from "react-toastify";

import { loginService } from "@/services/login";
import { getT } from "@/utils/helpers";

interface SendOtpData {
  systemUserId: string | number;
}

interface SendOtpStore {
  data: unknown;
  error: unknown;
  sendOtp: (sendOtp: SendOtpData) => Promise<void>;
}

export const useSendOtpStoreStore = create<SendOtpStore>()(
  immer((set) => ({
    data: {},
    error: null,
    sendOtp: async (sendOtp) => {
      try {
        const t = await getT("login");
        const data = (await loginService.sendOtp({
          systemUserId: sendOtp.systemUserId,
          otpType: 1,
          otpChannel: 1,
        })) as unknown as { body?: unknown };
        toast.success(t("againSentCode") as string);
        set({ data: data.body });
      } catch {
        set({ error: true });
      }
    },
  }))
);
